export default class TimeActivitiesStatistics
{
    
    constructor(activities)
    {
        this.activities = activities;
    }

    hours()
    {
        let total = this.activities.map(a => a.getTimeDifferenceInSeconds()).reduce((a, b) => a + b, 0);
        
        if ( total == 0 ) {
            return '00h00';
        }
        
        var hours = Math.floor(total / 3600) < 10 ? ("00" + Math.floor(total / 3600)).slice(-2) : Math.floor(total / 3600);
        var minutes = ("00" + Math.floor((total % 3600) / 60)).slice(-2);
        var seconds = ("00" + (total % 3600) % 60).slice(-2);
        return `${hours}h${minutes}`;
    }

    price()
    {
        return this.activities.map(a => a.getInvoicablePrice()).reduce((a, b) => a + b, 0);
    }

    cost()
    {
        return this.activities.map(a => a.getTotalCostPrice()).reduce((a, b) => a + b, 0);
    }

}